<template>
  <b-card
    style="background-color: rgb(255, 127, 96, 0.0); width: 100%; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;"
  >
    <div>
      <span style="font-size:20px; color: #fff;">สัดส่วนเวลาในการปล่อยไฟแต่ละ Phase (วัน)</span>
    </div>
    <div>
      <app-echart-doughnut
        :series="series"
        :title="title"
      />
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */
import {
  BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartDoughnut from './AppEchartDoughnut.vue'

export default {
  components: {
    BCard,
    AppEchartDoughnut,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      check: '',
      title: {
        text: '',
        left: 'center',
        top: 'center',
        textStyle: {
          fontSize: 30,
          color: 'white',
        },
      },
      series: [
        {
          color: ['#FFB100', '#1F8A70', '#5B8FB9', '#FF6E31'],
          name: '',
          type: 'pie',
          selectedMode: 'single',
          radius: [0, '50%'],
          label: {
            position: 'inner',
            fontSize: 12,
            formatter: ' {b}: {c} %',
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: '', name: 'Phase1',
            },
            {
              value: '', name: 'Phase2',
            },
            {
              value: '', name: 'Phase3', selected: true,
            },
            {
              value: '', name: 'Phase 4',
            },
          ],
        },
        {
          color: ['#579BFE', '#4EAF51', '#FF805D'],
          name: 'Access From',
          type: 'pie',
          radius: [120, '80%'],
          labelLine: {
            length: 30,
          },
          label: {
            textStyle: {
              color: '#fff',
            },
            position: 'outside',
            fontSize: 12,
            formatter: ' {b}: {c} วินาที',
          },
          data: [
            {
              value: '', name: 'Phase1',
            },
            {
              value: '', name: 'Phase2',
            },
            {
              value: '', name: 'Phase3',
            },
            {
              value: '', name: 'Phase 4',
            },
          ],
        },
      ],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getPieData()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getPieData()
    }, 300000)
  },
  methods: {
    getPieData() {
      axios
        .post('/getPieTrafficDetail', { wid: this.$route.query.wid })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.check = response.data[0].traffic_light_percent_phase4
          this.series[1].data[0].value = response.data[0].traffic_light_current_phase1
          this.series[1].data[1].value = response.data[0].traffic_light_current_phase2
          this.series[1].data[2].value = response.data[0].traffic_light_current_phase3
          const total = response.data[0].traffic_light_current_phase1 + response.data[0].traffic_light_current_phase2 + response.data[0].traffic_light_current_phase3 + response.data[0].traffic_light_current_phase4
          const percent1 = (this.series[1].data[0].value * total) / 100
          const percent2 = (this.series[1].data[1].value * total) / 100
          const percent3 = (this.series[1].data[2].value * total) / 100
          this.series[0].data[0].value = Math.round(percent1)
          this.series[0].data[1].value = Math.round(percent2)
          this.series[0].data[2].value = Math.round(percent3)
          if (response.data[0].PhaseNo > 3) {
            this.series[1].data[3].value = response.data[0].traffic_light_current_phase4
            const percent4 = (this.series[1].data[3].value * total) / 100
            this.series[0].data[3].value = Math.round(percent4)
            console.log(111222, total)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style >
</style>
